import request from '/src/utils/request';

// 生成微信支付二维码
export function ApiPayWechat(query) {
    return request({
        url: '/pay/wechat/wechatPay',
        method: 'post',
        data: query,
    });
}